export default {"src":"/_next/static/media/Social_facebook.940dd4f0.svg","height":683,"width":683,"blurWidth":0,"blurHeight":0};